import React from 'react';
import { Button } from '@homeexchange/panorama';
import { useCancelButton } from './useCancelButton';
import i18n from '../../../i18n';
export var ButtonCancellation = function (_a) {
    var conversation = _a.conversation, user = _a.user, isFullWidth = _a.isFullWidth;
    var _b = useCancelButton({
        conversation: conversation,
        user: user
    }), canCancel = _b.canCancel, onClickCancelButton = _b.onClickCancelButton;
    return (canCancel() && (React.createElement(Button, { onClick: onClickCancelButton, hierarchy: "secondary", isFullWidth: isFullWidth }, i18n.t('exchange:action_cancel_exchange'))));
};
